<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: THE $SEERX TOKEN — tokenomics
  ════════════════════════════════════════════════════════════════════════════ -->
<section class="token-section" aria-labelledby="token-heading" id="dao">

    <!-- Ambient cyan glow -->
    <div class="token-section__glow" aria-hidden="true"></div>

    <div class="token-section__container">

        <!-- Mega title -->
        <h2 class="token-section__title" id="token-heading">
            {{ 'token_section.title' | translate }}
        </h2>

        <!-- 3-column layout -->
        <div class="token-section__grid">

            <!-- Left features — cyan left border -->
            <div class="token-section__features token-section__features--left">

                <div class="token-section__feature">
                    <div class="token-section__feature-bar token-section__feature-bar--cyan" aria-hidden="true"></div>
                    <div>
                        <h3 class="token-section__feature-title token-section__feature-title--cyan">
                            {{ 'token_section.feat1_title' | translate }}
                        </h3>
                        <p class="token-section__feature-body">{{ 'token_section.feat1_body' | translate }}</p>
                    </div>
                </div>

                <div class="token-section__feature">
                    <div class="token-section__feature-bar token-section__feature-bar--cyan" aria-hidden="true"></div>
                    <div>
                        <h3 class="token-section__feature-title token-section__feature-title--cyan">
                            {{ 'token_section.feat2_title' | translate }}
                        </h3>
                        <p class="token-section__feature-body">{{ 'token_section.feat2_body' | translate }}</p>
                    </div>
                </div>

            </div>

            <!-- Center — donut chart -->
            <div class="token-section__chart" aria-label="$SEERX token distribution chart">
                <div class="token-section__chart-wrap">
                    <img src="/assets/images/png/token-chart.png" alt="$SEERX token distribution donut chart" loading="lazy" />
                    <div class="token-section__chart-overlay">
                        <strong class="token-section__chart-symbol">{{ 'token_section.chart_symbol' | translate
                            }}</strong>
                        <span class="token-section__chart-supply">{{ 'token_section.chart_supply' | translate }}</span>
                    </div>
                </div>
            </div>

            <!-- Right features — lime right border -->
            <div class="token-section__features token-section__features--right">

                <div class="token-section__feature token-section__feature--right">
                    <div class="token-section__feature-bar token-section__feature-bar--lime" aria-hidden="true"></div>
                    <div>
                        <h3 class="token-section__feature-title token-section__feature-title--lime">
                            {{ 'token_section.feat3_title' | translate }}
                        </h3>
                        <p class="token-section__feature-body">{{ 'token_section.feat3_body' | translate }}</p>
                    </div>
                </div>

                <div class="token-section__feature token-section__feature--right">
                    <div class="token-section__feature-bar token-section__feature-bar--lime" aria-hidden="true"></div>
                    <div>
                        <h3 class="token-section__feature-title token-section__feature-title--lime">
                            {{ 'token_section.feat4_title' | translate }}
                        </h3>
                        <p class="token-section__feature-body">{{ 'token_section.feat4_body' | translate }}</p>
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>